import { render, staticRenderFns } from "./ShowObjective.vue?vue&type=template&id=585b6194&"
import script from "./ShowObjective.vue?vue&type=script&lang=js&"
export * from "./ShowObjective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports